const loadingExportPdfV2 = (state, payload) => {
  state.loadingExportPdfV2 = payload
}

const loadingExportImage = (state, payload) => {
  state.loadingExportImage = payload
}

const loadingExportExcelV2 = (state, payload) => {
  state.loadingExportExcelV2 = payload
}

const loadingExportExcelV5 = (state, payload) => {
  state.loadingExportExcelV5 = payload
}

export default {
  loadingExportPdfV2,
  loadingExportImage,
  loadingExportExcelV2,
  loadingExportExcelV5,
}
